import React, { useMemo } from "react";
import { useInView } from "react-intersection-observer";

/**
 * FadeUp Component
 *
 * Renders its children with a smooth fade-up animation when the component comes into view.
 *
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - Content to animate.
 * @returns {JSX.Element} The rendered fade-up element.
 */
const FadeUp = ({ children }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  const animationStyle = useMemo(
    () => ({
      transform: inView ? "translateY(0)" : "translateY(150px)",
      opacity: inView ? 1 : 0,
      transition:
        "opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    }),
    [inView]
  );

  return (
    <div ref={ref} style={animationStyle}>
      {children}
    </div>
  );
};

export default FadeUp;
